import { Text } from "@chakra-ui/react";

export function UserWalletEditsScreen() {
    return (
        <>
        <Text>User Wallet Edits</Text>
        </>
    )
 }